import React, { FC } from 'react';
import { LayoutProps } from './models';

import Navbar from 'app/components/Navbar';
import Footer from 'app/components/Footer';
import { NavigationContextProvider } from 'app/contexts/NavigationContext';
import { RegisterModalProvider } from 'app/contexts/RegisterModalContext';

import './Layout.scss';
import 'app/styles/main.scss';

const Layout: FC<LayoutProps> = ({ children }) => {
  return (
    <RegisterModalProvider>
      <NavigationContextProvider>
        <Navbar />
        <main className="layout__body">{children}</main>
        <Footer />
      </NavigationContextProvider>
    </RegisterModalProvider>
  );
};

export default Layout;
